import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../../js/api/_config";
import { format, isValid, parseISO } from "date-fns";

export const fetchCalenderCount = createAsyncThunk(
  "notifications/fetchCalenderCount",
  async (params, { rejectWithValue }) => {
    try {

      const today = new Date();

      const start = new Date(today);
      start.setUTCHours(0, 0, 0, 0);

      // const end = new Date(today);
      // end.setUTCHours(23, 59, 59, 999);

      const payload = {
        recruiterId: params.recID,
        startDate: start.toISOString(),
        endDate: start.toISOString(),
      };
     
      const response = await axios.post(ENDPOINTS.CALENDAR.GET_CALENDER_EVENTS_COUNT, payload);

      const data = { totalCalls: 0, remainingCalls: 0};

      if (response.data && response.data.success) {
        const today = format(new Date(), "yyyy-MM-dd");
        const filteredData = response.data.data.filter(item => {
          const parsedDate = parseISO(item?.date || "");
          return isValid(parsedDate) && format(parsedDate, "yyyy-MM-dd") === today;
        });

        if (filteredData.length > 0) {
          data.totalCalls = filteredData[0].totalCalls || 0;
          data.remainingCalls = filteredData[0].remainingCalls || 0;
        }

      }
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const calenderCountSlice = createSlice({
  name: "calendercount",
  initialState: {
    totalCalls: 0,
    remainingCalls: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCalenderCount.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCalenderCount.fulfilled, (state, action) => {
        state.loading = false;
        state.totalCalls = action.payload.totalCalls;
        state.remainingCalls = action.payload.remainingCalls;
      })
      .addCase(fetchCalenderCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default calenderCountSlice.reducer;
